import $ from 'jquery';
import ConfigD from './ConfigD';
//var $ = window.jQuery;

class ExecutaRest {

    Post(path, data) {

        var ws = ConfigD.getWSURL();

        return new Promise(function (resolve, reject) {

            var Data = null;
            try {
                if (data != null) {
                    Data = JSON.stringify(data);
                }
            }
            catch (error) {
                reject('Falha na conversão dos dados - Parse');
            }

            $.support.cors = true;

            $.ajax({
                dataType: "json",
                crossDomain: true,
                contentType: "application/json; charset=utf-8",
                headers: {
                    Accept: "application/json",
                    "Access-Control-Allow-Origin": "*"
                },
                type: "POST",
                url: ws + path,
                data: Data,
                cache: false,
                success: resolve,
                async: true,
                error: function (xhr, textStatus, errorThrown) {
                    reject(xhr, textStatus, errorThrown);
                },
            });
        });
    }

    Get(path, data) {

        var ws = ConfigD.getWSURL();

        return new Promise(function (resolve, reject) {

            var Data = null;
            try {
                if (data != null) {
                    Data = JSON.stringify(data);
                }
            }
            catch (error) {
                reject('Falha na conversão dos dados - Parse');
            }

            $.support.cors = true;

            $.ajax({
                dataType: "json",
                crossDomain: true,
                contentType: "application/json; charset=utf-8",
                headers: {
                    Accept: "application/json",
                    "Access-Control-Allow-Origin": "*"
                },
                type: "GET",
                url: ws + path,
                data: Data,
                cache: false,
                success: resolve,
                async: true,
                error: function (xhr, textStatus, errorThrown) {
                    
                    reject(xhr, textStatus, errorThrown);
                },
            });
        });
    }

    Put(path, data) {

        var ws = ConfigD.getWSURL();

        return new Promise(function (resolve, reject) {

            var Data = null;
            try {
                if (data != null) {
                    Data = JSON.stringify(data);
                }
            }
            catch (error) {
                reject('Falha na conversão dos dados - Parse');
            }

            $.support.cors = true;

            $.ajax({
                dataType: "json",
                crossDomain: true,
                contentType: "application/json; charset=utf-8",
                headers: {
                    Accept: "application/json",
                    "Access-Control-Allow-Origin": "*"
                },
                type: "PUT",
                url: ws + path,
                data: Data,
                cache: false,
                success: resolve,
                async: true,
                error: function (xhr, textStatus, errorThrown) {
                    
                    reject(xhr, textStatus, errorThrown);
                },
            });
        });
    }

    Delete(path, data) {

        var ws = ConfigD.getWSURL();

        return new Promise(function (resolve, reject) {

            var Data = null;
            try {
                if (data != null) {
                    Data = JSON.stringify(data);
                }
            }
            catch (error) {
                reject('Falha na conversão dos dados - Parse');
            }

            $.support.cors = true;

            $.ajax({
                dataType: "json",
                crossDomain: true,
                contentType: "application/json; charset=utf-8",
                headers: {
                    Accept: "application/json",
                    "Access-Control-Allow-Origin": "*"
                },
                type: "DELETE",
                url: ws + path,
                data: Data,
                cache: false,
                success: resolve,
                async: true,
                error: function (xhr, textStatus, errorThrown) {
                    
                    //está dessa forma no rubix, mas reponsteText não existe. 
                    //reject(JSON.parse(xhr.responseText), textStatus, errorThrown);
                    reject(xhr, textStatus, errorThrown);
                },

            });
        });
    }

    PostArquivoAtendimento(idAtendimento, idHistorico, fileData, visivel)
    {

        //fileData é do tipo:
        //fileData = document.getElementById("fileUpload").files[0];

        var ws = ConfigD.getWSURL();

        return new Promise(function (resolve, reject) {

            var urlWSArquivo = ws + 'ArquivoHashRESTSL.svc/rest/UploadArquivoAtendimentoHistoricoREST?idAtendimento=' + idAtendimento + '&idHistorico=' + idHistorico +'&fileName=' + fileData.name+'&visivel=' + visivel;

            $.support.cors = true;

            $.ajax({
                dataType: "json",
                crossDomain: true,
                contentType: "application/octet-stream", // Set content type to false as jQuery will tell the server its a query string request
                processData: false, // Don't process the files
                headers: {
                    Accept: "application/json",
                    "Access-Control-Allow-Origin": "*"
                },
                type: "POST",
                url: urlWSArquivo,
                data: fileData,
                cache: false,
                success: resolve,
                async: false,
                error: function (xhr, textStatus, errorThrown) {
                    
                    //está dessa forma no rubix, mas reponsteText não existe. 
                    //reject(JSON.parse(xhr.responseText), textStatus, errorThrown);
                    reject(xhr, textStatus, errorThrown);
                },

            });
        });

    }   


}

export default ExecutaRest;



/** WEBPACK FOOTER **
 ** ./src/components/util/ExecutaRest.js
 **/